export enum CacheKey {
  USER_SESSION = 'USER_SESSION',
  USER_LANGUAGE = 'USER_LANGUAGE',
}
